import Separator from '../step-landing-page/Separator';
import { Step } from 'signup-constants/Step';
import { OAuthProviders } from './OAuthProviders';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
import { useOAuthSignup } from './useOAuthSignup';
import { AppleButton } from '../apple/AppleButton';
import { GoogleOAuthButton } from '../google-authentication/GoogleOAuthButton';
import { MicrosoftButton } from '../microsoft/MicrosoftButton';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import LinkedinButton from '../linkedin/LinkedInButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OAuthToComponent = {
  [OAuthProviders.Microsoft]: /*#__PURE__*/_jsx(MicrosoftButton, {}),
  [OAuthProviders.Google]: /*#__PURE__*/_jsx(GoogleOAuthButton, {}),
  [OAuthProviders.Apple]: /*#__PURE__*/_jsx(AppleButton, {})
};
export const OAuthSignupSection = ({
  shouldShowSeperator = true
}) => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const {
    isAssignedToVariant: isACQ0154Variant
  } = useExperiment(ExperimentKeys.ACQ0154, TrackWhen.never);
  const renderOAuths = () => {
    const oAuths = Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [OAuthToComponent[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
    if (isACQ0154Variant()) {
      oAuths.push( /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(LinkedinButton, {})
      }, "linkedin"));
    }
    return oAuths;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-4",
    children: [renderOAuths(), atLeastOneOAuthEnabled && shouldShowSeperator && /*#__PURE__*/_jsx(Separator, {
      message: `views.${Step.LandingPage}.separator`
    })]
  });
};